<template>
  <div :class="columnClasses">
    <slot style="justify-content:center"></slot>
  </div>
</template>

<script>
export default {
  props: {
    cols: {
      type: Object,
      default: () => {
        return { xs: 12, sm: 12, md: 6, lg: 6, xl: 4 };
      },
    },
  },
  data() {
    return {
      columns: {},
    };
  },
  mounted() {},
  computed: {
    columnClasses() {
      let columns = {};
      columns.xs = this.cols.xs ? this.cols.xs : 12;
      columns.sm = this.cols.sm ? this.cols.sm : columns.xs;
      columns.md = this.cols.md ? this.cols.md : columns.sm;
      columns.lg = this.cols.lg ? this.cols.lg : columns.md;
      columns.xl = this.cols.xl ? this.cols.xl : columns.lg;

      return `nbox nxs-${columns.xs} nsm-${columns.sm} nmd-${columns.md} nlg-${columns.lg} nxl-${columns.xl} `;
    },
  },
};
</script>

<style>
.nbox {
  box-sizing: border-box;
 
}
/* xs - extra small */
@media (max-width: 599px) {
  .nxs-1 {
    width: 8.3%;
  }
  .nxs-2 {
    width: 16.6%;
  }
  .nxs-3 {
    width: 25%;
  }
  .nxs-4 {
    width: 33.3%;
  }
  .nxs-5 {
    width: 41.6%;
  }
  .nxs-6 {
    width: 50%;
  }
  .nxs-7 {
    width: 58.3%;
  }
  .nxs-8 {
    width: 66.6%;
  }
  .nxs-9 {
    width: 75%;
  }
  .nxs-10 {
    width: 83.3%;
  }
  .nxs-11 {
    width: 91.6%;
  }
  .nxs-12 {
    width: 100%;
  }
}
/* sm - small */
@media (min-width: 600px) and (max-width: 959px) {
  .nsm-1 {
    width: 8.3%;
  }
  .nsm-2 {
    width: 16.6%;
  }
  .nsm-3 {
    width: 25%;
  }
  .nsm-4 {
    width: 33.3%;
  }
  .nsm-5 {
    width: 41.6%;
  }
  .nsm-6 {
    width: 50%;
  }
  .nsm-7 {
    width: 58.3%;
  }
  .nsm-8 {
    width: 66.6%;
  }
  .nsm-9 {
    width: 75%;
  }
  .nsm-10 {
    width: 83.3%;
  }
  .nsm-11 {
    width: 91.6%;
  }
  .nsm-12 {
    width: 100%;
  }
}
/* md - medium */
@media (min-width: 960px) and (max-width: 1263px) {
  .nmd-1 {
    width: 8.3%;
  }
  .nmd-2 {
    width: 16.6%;
  }
  .nmd-3 {
    width: 25%;
  }
  .nmd-4 {
    width: 33.3%;
  }
  .nmd-5 {
    width: 41.6%;
  }
  .nmd-6 {
    width: 50%;
  }
  .nmd-7 {
    width: 58.3%;
  }
  .nmd-8 {
    width: 66.6%;
  }
  .nmd-9 {
    width: 75%;
  }
  .nmd-10 {
    width: 83.3%;
  }
  .nmd-11 {
    width: 91.6%;
  }
  .nmd-12 {
    width: 100%;
  }
}

/* lg - large */
@media (min-width: 1264px) and (max-width: 1904px) {
  .nlg-1 {
    width: 8.3%;
  }
  .nlg-2 {
    width: 16.6%;
  }
  .nlg-3 {
    width: 25%;
  }
  .nlg-4 {
    width: 33.3%;
  }
  .nlg-5 {
    width: 41.6%;
  }
  .nlg-6 {
    width: 50%;
  }
  .nlg-7 {
    width: 58.3%;
  }
  .nlg-8 {
    width: 66.6%;
  }
  .nlg-9 {
    width: 75%;
  }
  .nlg-10 {
    width: 83.3%;
  }
  .nlg-11 {
    width: 91.6%;
  }
  .nlg-12 {
    width: 100%;
  }
}

/* xl - extra large */
@media (min-width: 1905px) {
  .nxl-1 {
    width: 8.3%;
  }
  .nxl-2 {
    width: 16.6%;
  }
  .nxl-3 {
    width: 25%;
  }
  .nxl-4 {
    width: 33.3%;
  }
  .nxl-5 {
    width: 41.6%;
  }
  .nxl-6 {
    width: 50%;
  }
  .nxl-7 {
    width: 58.3%;
  }
  .nxl-8 {
    width: 66.6%;
  }
  .nxl-9 {
    width: 75%;
  }
  .nxl-10 {
    width: 83.3%;
  }
  .nxl-11 {
    width: 91.6%;
  }
  .nxl-12 {
    width: 100%;
  }
}
</style>
